<template>
  <div id="app">
    <div class="app">
      <Header />
      <main>
        <router-view />
      </main>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer
  }
};
</script>


<style lang="scss">
.app {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - #{$element-height});
}
body {
  main {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  &:before {
    background-image: url("./assets/bg.jpg");
  }
}
</style>
